export function formatImageSet(images: string[]) {
  return images.map((image, index) => `${image} ${index + 1}x`).join(', ')
}
